import script from "./BaseRightDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRightDialog.vue?vue&type=script&setup=true&lang=js"

import "./BaseRightDialog.vue?vue&type=style&index=0&id=77c58c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c58c6a"]])

export default __exports__